import React, { useEffect, useState } from "react";
import { FcPlus } from "react-icons/fc";
import { FcMinus } from "react-icons/fc";
import blogFetch from "../../axios/config";
import { getIdCompany } from "../../utils/constantes";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextField from "@mui/material/TextField";
import "./Questions.css";
import Switch from '@mui/material/Switch';
const { forwardRef, useImperativeHandle } = React;

export default forwardRef((props, ref) => {
  const [type, setType] = useState("");
  const [openInputs, setOpenInputs] = useState(["", ""]);
  const [answers, setAnswers] = useState("");
  const [company, setCompany] = useState("");
  const [description, setDescription] = useState(null);
  const [selectedValue, setSelectedValue] = useState(null);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    getQuestions();
  }, []);

  useImperativeHandle(ref, () => ({
    addQuestions,
    updateQuestions,
    deleteQuestions,
  }));

  function updateInputValues() {
    let newVaue = [...openInputs];
    newVaue = newVaue.toString();
    newVaue = newVaue.replaceAll(",", ";");
    setAnswers(newVaue);
  }

  function handleOpenInputChange(index, value) {
    const newOpenInputs = [...openInputs];
    newOpenInputs[index] = value;
    setOpenInputs(newOpenInputs);
    updateInputValues(); // adiciona esta linha para atualizar answers
  }

  const addQuestions = async () => {
    let questionsId = null;
    if (selectedValue != null) {
      questionsId = selectedValue.qeS_PK_idQuestion;
    }
    let question = {
      qeS_PK_idQuestion: questionsId,
      qeS_description: description,
      qeS_typeAnswer: type,
      qeS_active: true,
      qeS_possibleAnswer: answers,
      qeS_FK_company: company,
      EQP_FK_company: 1,
      qeS_FK_companyId: getIdCompany(),
    };
    try {
      const response = await blogFetch.post("/question", question);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };
  const updateQuestions = async () => {
    let questionsId = null;
    if (selectedValue != null) {
      questionsId = selectedValue.qeS_PK_idQuestion;
    }

    let question = {
      qeS_PK_idQuestion: questionsId,
      qeS_description: description,
      qeS_typeAnswer: type,
      qeS_active: true,
      qeS_possibleAnswer: answers,
      EQP_FK_company: 1,
      qeS_FK_company: company,
      qeS_FK_companyId: getIdCompany(),
    };

    try {
      const response = await blogFetch.put(
        "/question/" + props.idQuestions,
        question
      );
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const getQuestions = async () => {
    if (props.idQuestions != null) {
      setLoading(true);
      try {
        let response = await blogFetch.get(`/question/${props.idQuestions}`);
        let data = response.data;
        setTimeout(() => {
          setDescription(data.qeS_description);
          setSelectedValue(data.manufacturer);
          setType(data.qeS_typeAnswer.toString())
          setLoading(false);
        }, 300);
        return data;
      } catch (error) {
        console.error(error);
      }
    }
  };

  const deleteQuestions = async () => {
    try {
      const response = await blogFetch.delete("/question/" + props.idQuestions);
      return response.status;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  return (
    <>
      {loading ? (
        <div className="loading-container">
          <center>
            <FontAwesomeIcon icon={faSpinner} spin />
          </center>
        </div>
      ) : (
        <div>
          <div className="mb-3">
            <TextField
              id="outlined-basic"
              label="Razão Social"
              variant="outlined"
              fullWidth
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <h5 className="tipo_pergunta">Tipo de Resposta:</h5>
          <div className="type_question">
            <div className="input_type_question">
              <input
                className="input_cursor"
                type="radio"
                id="yes-no"
                name="type"
                value="1"
                checked={type === "1"}
                onChange={() => setType("1")}
              />
              <label className="input_cursor" htmlFor="yes-no">
                Sim/Não
              </label>
            </div>
            <div className="input_type_question">
              <input
                className="input_cursor"
                type="radio"
                id="open-ended"
                name="type"
                value="3"
                checked={type === "3"}
                onChange={() => setType("3")}
              />
              <label className="input_cursor" htmlFor="open-ended">
                Aberta
              </label>
            </div>
            <div className="input_type_question">
              <input
                className="input_cursor"
                type="radio"
                id="multiple-choice"
                name="type"
                value="2"
                checked={type === "2"}
                onChange={() => setType("2")}
              />
              <label className="input_cursor" htmlFor="multiple-choice">
                Definida
              </label>
            </div>
          </div>
          {type === "2" ? (
            <div className="container_answer">
              <h5> Reposta Padrão:</h5>
              <div className="add_remove_button">
                <FcMinus
                  size="30px"
                  variant="primary"
                  type="button"
                  className=""
                  onClick={() => {
                    let newInput = [...openInputs];
                    newInput.pop();
                    setOpenInputs(newInput);
                  }}
                />
                <FcPlus
                  size="30px"
                  variant="primary"
                  type="button"
                  className=""
                  onClick={() => setOpenInputs([...openInputs, ""])}
                />
              </div>
              <div className="answer_container">
                {openInputs.map((openInput, index) => (
                  <div key={index} className="answer_div">
                    <div className="form-floating mb-2">
                      <input
                        type="text"
                        class="form-control answer_input"
                        id="floatingInput"
                        placeholder="Resposta"
                        value={openInput}
                        onChange={(event) =>
                          handleOpenInputChange(index, event.target.value)
                        }
                      />
                      <label for="floatingInput">Resposta: {index + 1}</label>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : null}
        </div>
      )}
    </>
  );
});
